<template>
  <index></index>
</template>


<script>
  import Index from './IndexMain.vue'

  export default {
    name: 'dashboard',
    components: {
      Index
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?772d16ec